export default {
    prompt:"Image Size",
    field:"--imageHeight",
    type:"style",
    default:50,
    property:"--imageHeight",
    range:[0,100],
    slider:true,
    unit:"px"
}